<template>
  <div class="loading-overlay-container">
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />

    <!-- Inner body -->
    <div class="loading-inner-container">
      <h2 style="text-align: center;">
        {{ title }}
      </h2>
      <label
        class="subtitle"
        v-html="message"
      />
      
      <div class="alert-buttons-container">
        <button
          class="cancel-btn"
          @click="close()"
        >
          {{ cancelText }}
        </button>
        <button
          class="submit-btn"
          @click="submit()"
        >
          {{ submitText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertConfirmComponent',
  components: {},
  props: ['title', 'message', 'submitText', 'cancelText'],
  data () {
    return {
      
    }
  },
  computed: {
    /**
     * @public
     */
    invoiceIsLoading: function () {
      return this.$store.state.invoiceIsLoading
    }
  },
  mounted () {},
  methods: {
    /**
     * Gets called when user clicks OK button
     * @public
     */
    close: function () {
        this.$emit('close')
    },
    submit: function() {
        this.$emit('submit')
    }
    
  }
}
</script>

<style scoped>
    .alert-buttons-container {
        margin-top: 32px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 1.5em;
    }
    
    .cancel-btn {
        background-color: #ffffff;
        color: #333333;
        border-radius: 8px;
        margin: 0;
        border: 1px solid rgba(51, 51, 51, 0.7);
        flex-basis: 55%;
    }

    .submit-btn {
        background-color: #007AFF;
        border-radius: 8px;
        color: #ffffff;
        border: none;
        flex-basis: 40%;
    }
</style>
